module.exports = __webpack_public_path__ + "img/hays-suchail-draw.53333a08.jpg";